import { centsToDollars, parsePrice } from "helpers/price";

export function BreakdownHeader({
  title,
  count,
  totalInCents,
  noun,
  expanded,
  onToggle,
}: {
  title: string;
  count: number;
  totalInCents: number;
  noun: string;
  expanded: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      className="breakdown-header"
      aria-expanded={expanded}
      onClick={onToggle}
    >
      <span className="flex flex-wrap align-items-baseline gap-2">
        <span
          className="text-base font-semibold"
          style={{ color: "var(--brand-black)" }}
        >
          {title}
        </span>

        <span className="text-base" style={{ color: "var(--brand-gray-500)" }}>
          {parsePrice(centsToDollars(totalInCents))} across {count} {noun}
          {count === 1 ? "" : "s"}
        </span>
      </span>

      <i
        className={expanded ? "pi pi-chevron-up" : "pi pi-chevron-down"}
        style={{ color: "var(--brand-gray-600)" }}
      />
    </button>
  );
}
